import { el, setChildren } from 'redom';

class Label {

  constructor() {
    this.el = el('label.navigable-list-option-label', {
      class: 'ellipsis'
    });
  }

  update(option) {
    this.el.textContent = option.label;
  }

}

class NavigableOption {

  constructor(options) {

    this.index = -1;
    this.selected = false;
    this.onSelect = options.onSelect;
    this.onUnselect = options.onUnselect;
    this.onHighlight = options.onHighlight;
    this.navigableList = options.navigableList;

    if (options.OptionEntry !== void 0) {
      this.label = new options.OptionEntry();
    } else {
      this.label = new Label();
    }

    this.el = el('li.navigable-list-option', {
      onclick: this.handleOptionClick.bind(this),
      // onmouseenter: this.handleMouseEnter.bind(this)
    }, [this.label]);

  }

  handleOptionClick(event) {

    event.stopPropagation();

    this.selectOrUnselect();

    return false;

  }

  handleMouseEnter(event) {

    this.onHighlight(this.index);

  }

  update(option, index, options, context) {

    this.index = index;

    if (option.labelView) {
      setChildren(this.el, [option.labelView]);
    } else {
      this.label.update(option, index, options, context);
    }

    if (this.navigableList.isSelectedOption(option) === true) {
      this.selected = true;
      this.el.classList.add('selected');
    } else {
      this.selected = false;
      this.el.classList.remove('selected');
    }

    if (this.navigableList.isHighlightedOption(index) === true) {
      this.el.classList.add('hovered');
    } else {
      this.el.classList.remove('hovered');
    }

  }

  selectOrUnselect() {

    if (this.selected === true) {
      this.onUnselect(this.index);
    } else {
      this.onSelect(this.index);
    }

  }

}

export default NavigableOption;